import { render } from "./TheLogin.vue?vue&type=template&id=b521efaa"
import script from "./TheLogin.vue?vue&type=script&lang=ts"
export * from "./TheLogin.vue?vue&type=script&lang=ts"
script.render = render

export default script